import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { Popover, ListGroup, OverlayTrigger } from "react-bootstrap";

import {
  clearNotifications,
  getAllNotifications,
  getNotificationsCount,
} from "../service";

import { toast } from "Layout/slice";
import NotificationCard from "./Card";
import { iconClose, InActiveNotificationIcon } from "assets/icons";
import { Button } from "components/Button";
import { useNavigation } from "utils/navigate";
import { NotificationPopover, NotificationCount } from "./Notification.styles";

export const NotificationPanel = () => {
  const dispatch = useDispatch();
  const { navigateToNotification } = useNavigation();

  const [total, setTotal] = useState(0);
  const [notifCount, setNotifCount] = useState(0);
  const [unseenCount, setUnseenCount] = useState(0);
  const [showViewAll, setShowViewAll] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [seenNotificationId, setSeenNotificationId] = useState([]);

  useEffect(() => {
    let intervalId;
    getNotifications();

    intervalId = setInterval(() => {
      listenNotificationCount();
    }, 30000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const listenNotificationCount = async () => {
    try {
      const count = await getNotificationsCount();
      setNotifCount(count);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  const handleClearNotifications = async () => {
    try {
      const ids = notifications.map((notification) => notification.id);
      await clearNotifications({
        notifications: ids,
      });
      getNotifications(1, true);
      dispatch(
        toast({
          body: "All notifications have been marked as read",
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getNotifications = async (page = 1, reset = false) => {
    try {
      const params = {
        page,
        size: 10,
      };
      const response = await getAllNotifications(params);
      setTotal(response.total_count);
      setUnseenCount(response.unseen.length);
      if (reset) {
        setNotifications(response.data);
      } else {
        setNotifications([...notifications, ...response.data]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAllNotificationClick = () => {
    navigateToNotification();
    onHide();
  };

  const handleSeeMoreClick = () => {
    setShowViewAll(true);
    getNotifications(2);
  };

  const handleNotificationClick = (id) => {
    setSeenNotificationId([...seenNotificationId, id]);
  };

  const onHide = () => {
    document.body.click();
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      rootClose
      overlay={
        <NotificationPopover id="popover-positioned-bottom">
          <Popover.Body className="body-wrapper">
            <Popover.Header as="h3">
              <span>Notifications</span>
              <img src={iconClose} onClick={onHide} />
            </Popover.Header>

            <div className="mark-as-read">
              {unseenCount > 0 && (
                <Button
                  variant="secondary"
                  size="large"
                  onClick={handleClearNotifications}
                >
                  Mark all as read
                </Button>
              )}
            </div>

            <ListGroup>
              {notifications.map((notification) => (
                <ListGroup.Item
                  key={notification.id}
                  className={classNames({
                    seen:
                      notification.seen ||
                      seenNotificationId.includes(notification.id),
                  })}
                >
                  <NotificationCard
                    {...notification}
                    showEnvelope={false}
                    handleClick={handleNotificationClick}
                    handleClearClick={() => getNotifications(1, true)}
                  />
                  <div className="divider "></div>
                </ListGroup.Item>
              ))}
              {notifications.length === 0 && (
                <ListGroup.Item className="no-data">{`You're all caught up`}</ListGroup.Item>
              )}
            </ListGroup>
            <div className="actions">
              {total > 10 && !showViewAll && (
                <Button onClick={handleSeeMoreClick}>See more</Button>
              )}

              {showViewAll && (
                <Button onClick={handleAllNotificationClick}>
                  View all notifications
                </Button>
              )}
            </div>
          </Popover.Body>
        </NotificationPopover>
      }
    >
      <NotificationCount>
        <div className="option">
          {(total > 0 || notifCount > 0) && <div className="indicator" />}

          <InActiveNotificationIcon
            alt="notification"
            className="icon-notification"
          />
        </div>
        {notifCount > 0 && <span className="count">{notifCount}</span>}
      </NotificationCount>
    </OverlayTrigger>
  );
};
